module.exports = __webpack_public_path__ + "img/Unit_Guide_port.434cd321.svg";